import React from 'react'; 
// import WalletComponent from '../components/wallet'

function WalletKit() {

  return (
    <div style={{marginTop: 300, marginBottom: 300}}>
      <p>WalletKit</p>
    </div>
  );
}

export default WalletKit;
